import type { components } from '@leanin/api-client';

export type LeaderRemovalView = components['schemas']['LeaderRemovalView'];
export type LeaderRemovalReason = LeaderRemovalView['reason'];

// Dialog order. The dialog's option labels live under
// `Moderation.leaderRemoval.reasons.*.label`; what the author is told (the
// notification row, the post banner, the chat tombstone) reads
// `Notifications.kinds.contentRemoved.reasons.*` so those three never drift.
export const LEADER_REMOVAL_REASONS: ReadonlyArray<LeaderRemovalReason> = [
  'promotional',
  'off_topic',
  'harassment',
  'other',
];


export const LEADER_REMOVAL_NOTE_MAX = 1000;
